export const initialDashboardState = () => ({
  fetchDashboardLoading: false,
  fetchDashboardFailure: false,
  fetchDashboardLoaded: false
});
